{
  "actionbar.actions": "Radnje",
  "actionbar.actionsAvailable": "Dostupne su radnje.",
  "actionbar.clearSelection": "Poništi izbor",
  "actionbar.selected": "Izabrano: {count}",
  "actionbar.selectedAll": "Sve je izabrano",
  "breadcrumbs.more": "Više stavki",
  "button.pending": "nerešeno",
  "calendar.invalidSelection": "Izabrani {selectedCount, plural, one {date} other {dates}} nije dostupan.",
  "combobox.noResults": "Nema rezultata",
  "contextualhelp.help": "Pomoć",
  "contextualhelp.info": "Informacije",
  "datepicker.endTime": "Završno vreme",
  "datepicker.startTime": "Početno vreme",
  "datepicker.time": "Vreme",
  "dialog.alert": "Upozorenje",
  "dialog.dismiss": "Odbaci",
  "dropzone.replaceMessage": "Otpustite datoteku radi zamene",
  "inlinealert.informative": "Informacije",
  "inlinealert.negative": "Greška",
  "inlinealert.notice": "Upozorenje",
  "inlinealert.positive": "Uspešno",
  "label.(optional)": "(opciono)",
  "label.(required)": "(obavezno)",
  "menu.moreActions": "Dodatne radnje",
  "notificationbadge.indicatorOnly": "Nova aktivnost",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Izaberite...",
  "picker.selectedCount": "{count, plural, =0 {No items selected} one {# item selected} other {# items selected}}",
  "slider.maximum": "Najviše",
  "slider.minimum": "Najmanje",
  "table.cancel": "Otkaži",
  "table.editCell": "Uredi ćeliju",
  "table.loading": "Učitavam...",
  "table.loadingMore": "Učitavam još...",
  "table.resizeColumn": "Promeni veličinu kolone",
  "table.save": "Sačuvaj",
  "table.sortAscending": "Sortiraj po rastućem redosledu",
  "table.sortDescending": "Sortiraj po opadajućem redosledu",
  "tag.actions": "Radnje",
  "tag.hideButtonLabel": "Prikaži manje",
  "tag.noTags": "Ne postoji",
  "tag.showAllButtonLabel": "Prikaži sve ({tagCount, number})",
  "toast.clearAll": "Obriši sve",
  "toast.collapse": " Skupi",
  "toast.showAll": "Prikaži sve"
}
